
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invoice/[id]",
      function () {
        return require("private-next-pages/invoice/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invoice/[id]"])
      });
    }
  